// extracted by mini-css-extract-plugin
module.exports = {"form":"_395b52a"};